import moment from 'moment';
function format(input, format2) {
  return moment(input).format(format2);
}
function parse(dateString, format2) {
  const parsed = moment(dateString, format2, true);
  if (parsed.isValid()) {
    return {
      isValid: true,
      date: parsed.toDate()
    };
  }
  return {
    isValid: false,
    error: "Invalid date. Must be on the format \"".concat(format2, "\"")
  };
}
export { format, parse };
//# sourceMappingURL=legacyDateFormat.esm.js.map
